import { useTranslation } from 'next-i18next'
import { useProductAttributes } from '~/hooks/useProductAttributes'
import { DetailsTableTencelRow } from './DetailsTableTencelRow'

export interface DetailEntry {
  name: string
  value: string | number | null | undefined
  valueStr: string
  type: 'choice' | 'text'
}

interface DetailsTableProps {
  detailArray: Array<DetailEntry>
}

const isTencel = (value: string) =>
  value?.toLowerCase().includes('tencel') || value?.toLocaleLowerCase().includes('lyocell')

const DetailsTable: React.FC<DetailsTableProps> = ({ detailArray }) => {
  const { t } = useTranslation()
  const { findLabel } = useProductAttributes()

  const valueResolver = (valueStr: string, value: string | number, type: DetailEntry['type']) => {
    if (type === 'choice') {
      return findLabel({
        attributeCode: valueStr,
        attributeValue: value,
      })
    }

    return value
  }

  return (
    <ul className="grid max-w-[500px] gap-4 text-12-20-sg">
      {detailArray.map(({ name, value, valueStr, type }) => {
        const resolvedValue = valueResolver(valueStr, value ?? '', type)
        return (
          !!value && (
            <li key={name} className="grid grid-cols-2 gap-4">
              {isTencel(resolvedValue.toString()) ? (
                <DetailsTableTencelRow name={name} label={resolvedValue.toString()} />
              ) : (
                <>
                  <strong className="font-medium">{t(name)}</strong>
                  <span className="font-extralight">{resolvedValue}</span>
                </>
              )}
            </li>
          )
        )
      })}
    </ul>
  )
}

export default DetailsTable
